import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType, HttpResponse } from "@angular/common/http";
import { HttpHelperService } from "./httphelper.service";
import { environment } from "../../../environments/environment";
import { Event } from "./../model/event";
import { ManualEvent } from "../model/manual-event";
import { ActiveEvent } from "../model/activeEvent";
import { HistoricalEvent } from "../model/historicalEvent";
import { ApiQueryBuilder } from "../Utilities/urlQueryBuilder";
import { Observable, throwError } from "rxjs";
import { catchError, filter, map } from "rxjs/operators";

export const API_URL = environment.apiUrl;

@Injectable()
export class EventService extends ApiQueryBuilder {
	constructor(
		private http: HttpClient,
		private httpHelperService: HttpHelperService
	) {
		super(API_URL);
	}

	getResidentEvents(residentId: string, month: number, year: number) {
		return this.http.get<Event[]>(
			`${API_URL}event/resident/${residentId}?month=${month}&year=${year}`,
			this.httpHelperService.getHttpOptions()
		);
	}

	/** Sensor events between two absolute instants - `from` inclusive, `to` exclusive. */
	getResidentEventsInRange(residentId: string, from: Date, to: Date) {
		return this.http.get<Event[]>(
			`${API_URL}event/resident/${residentId}`
			+ `?from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`,
			this.httpHelperService.getHttpOptions()
		);
	}

	getDashboardSummary(departmentIds: string[]) {
		let url = `${API_URL}event/dashboardevents`;

		if (departmentIds && departmentIds.length > 0) {
			const params = departmentIds.map(id => `departmentIds=${encodeURIComponent(id)}`).join("&");
			url = `${url}?${params}`;
		}

		return this.http.get<ActiveEvent[]>(
			url,
			this.httpHelperService.getHttpOptions()
		);
	}

	getDashboardEventsHistory(residentId: Number, activeEventId: Number) {
		const url = this.addSegment("event")
			.addSegment("DashboardEventsHistory")
			.setParam("residentId", residentId);

		if (activeEventId) {
			url.setParam("activeEventId", activeEventId);
		}

		const fullUrl = url.buildUrl();
		return this.http.get<HistoricalEvent[]>(
			fullUrl,
			this.httpHelperService.getHttpOptions()
		);
	}

	getResidentActiveEvents(residentId: number) {
		return this.http.get<ActiveEvent>(
			`${API_URL}event/residentdashboardevents?residentId=${residentId}`,
			this.httpHelperService.getHttpOptions()
		);
	}
}
